import { render, staticRenderFns } from "./apropos.vue?vue&type=template&id=c22d5b58&"
import script from "./apropos.vue?vue&type=script&lang=js&"
export * from "./apropos.vue?vue&type=script&lang=js&"
import style0 from "./apropos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports